import { useAuth } from '../contexts/AuthContext';

export const usePermissions = () => {
  const { user, canJoinActivities, isUser, isAdmin } = useAuth();

  return {
    // Activity permissions    
    canJoinActivities: canJoinActivities,
    
    // User permissions
    canViewProfile: (userId: string) => user?.id === userId,
    canEditProfile: (userId: string) => user?.id === userId,
    
    // Creator permissions
    // not implemented yet, to be determined
    // canVerifyOrganization: isCreator,
    // canManageOrganizationProfile: isCreator,
    
    // Application permissions
    canApplyToActivity: isUser,
    canWithdrawApplication: isUser,
    // canApproveApplication: isCreator,
    // canRejectApplication: isCreator,
  };
};